import { NavigationBar } from './NavigationBar.class';
import { defineComponent } from 'vue';

export default defineComponent({
	setup: () => {
		const codeBehind = new NavigationBar();
		return {
			...codeBehind,
			switchToTab: codeBehind.switchToTab.bind(codeBehind)
		};
	}
});
